import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Box, Page } from "signoxe/components/layout";
import {
  Popup,
  Icon,
  CustomIcon2,
  Switch,
  Button,
} from "signoxe/components/widgets";
import "./styles.scss";

import {
  toggleDeviceId,
  updateDeviceGroup,
  updateContentFeed,
  fetchDeviceGroups,
  confirmationRequest,
  fetchAssets,
} from "signoxe/actions";
import {
  CONTENT_FEEDS_RESOURCE,
  DEVICE_GROUPS_RESOURCE,
  DEVICES_RESOURCE,
} from "signoxe/api/resources";
import { getAuthTokenHeader } from "signoxe/actions/remote";
import { Link } from "react-router-dom/es";

import { getDeviceGroup, getProfile } from "signoxe/selectors";

import { callOnEnter } from "signoxe/utils/eventHelpers";

import { ContentFeedView } from "signoxe/components";

import { OrientationSelectWidget } from "signoxe/components/widgets/OrientationSelectWidget";

import URLAssetEditPage from "signoxe/components/AssetModal/components/Url";
import AQIAirvedaPage from "signoxe/components/AssetModal/components/Aqi_Airveda";
import FidsAssetPage from "signoxe/components/AssetModal/components/Fids";
import AQIAssetPage from "signoxe/components/AssetModal/components/Aqi";
import CalendarAssetPage from "signoxe/components/AssetModal/components/Calendar";
import HtmlPage from "signoxe/components/AssetModal/components/Html";
import GoogleSheetPage from "signoxe/components/AssetModal/components/GoogleSheet";
import DataPage from "signoxe/components/AssetModal/components/Data";
import YoutubePage from "signoxe/components/AssetModal/components/Youtube";
import TwitterPage from "signoxe/components/AssetModal/components/TwitterFeeds";
import WeatherPage from "signoxe/components/AssetModal/components/Weather";
import QuizAppPage from "signoxe/components/AssetModal/components/Quiz_App";
import ScrollerAppPage from "signoxe/components/AssetModal/components/Scroller";
import PollAppPage from "signoxe/components/AssetModal/components/Poll_App";

import Events from "signoxe/components/AssetModal/components/Events";
import aqiAirvedaIcon from "signoxe/images/app_icons/AQI.png";
;

import { CUSTOM_API_ROOT } from "signoxe/constants/config";

class AppPage extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      addMode: false,
      currentKey: null,
      toggleDisplay: false,
      searchTerm: "",
      filteredList: [],
      filteredFeaturesList: [],
      appData:this.props.profile  && this.props.profile.profile.package.allowed_apps
    };

    this.components = {
      fids: FidsAssetPage,
      aqi: AQIAssetPage,
      aqi_airveda: AQIAirvedaPage,
      quiz_app: QuizAppPage,
      youtube: YoutubePage,
      twitter: TwitterPage,
      calendar: CalendarAssetPage,
      url: URLAssetEditPage,
      html: HtmlPage,
      data: DataPage,
      sheets: GoogleSheetPage,
      weather: WeatherPage,
      scroller: ScrollerAppPage,
      poll: PollAppPage,
      //'events': Events
    };
  }

  closeToggle = () => {
    this.setState({ toggleDisplay: false });
  };

  switchComponent(key) {
    this.setState({ currentKey: key });
    this.setState({ toggleDisplay: !this.state.toggleDisplay });
  }

  close() {
    const { disable } = this.props;

    disable();
    this.setState({ currentKey: null, addMode: false });
  }

  handleChange = (e) => {
    this.setState({ searchTerm: e.target.value });
    const { searchTerm } = this.state;

    const filteredList = this.props.profile && this.props.profile.profile.system_apps.filter((item) =>
      item.displayName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const filteredFeaturesList = this.props.profile && this.props.profile.profile.package.apps.filter((item) =>
      item.displayName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    this.setState({ filteredList: filteredList });
    this.setState({ filteredFeaturesList: filteredFeaturesList });
  };

   isAllowedApp = (id) => {
    return this.props.profile && this.props.profile.profile.package.allowed_apps.includes(
     id
      );
   } 
  renderComponent(currentKey) {
    const Component = this.components[currentKey];
    if (typeof Component === "string") {
      return <div>Asset not yet supported.</div>;
    }
    return (
      <Component
        refresh={this.props.fetchAssets}
        history={this.props.history}
        disable={this.close.bind(this)}
      />
    );
  }

  render() {
    const { visible, disable, profile } = this.props;
 

    const {
      currentKey,
      toggleDisplay,
      searchTerm,
      filteredList,
      filteredFeaturesList,
      appData
    } = this.state;
    const isSystemApp = this.props.profile && this.props.profile.profile.package.allowed_apps.includes(
      2
      );
    console.log("currentley", currentKey)


    return (
      <Page className="asset-content-popup">
        <Box
          className="modal-wrapper"
          direction="column"
          justifyContent="center"
        >
          {this.state.addMode ? (
            <Box className="asset-wrapper">
              Component which would only be triggered if a new component is
              being added
            </Box>
          ) : (
            <Box className="asset-wrapper" direction="column">
              <div className="sub-component-list">
                {toggleDisplay == false ? (
                  <div className="input-group mt-1 mb-1 p-1 rounded">
                    <input
                      className="input-group-field"
                      type="text"
                      placeholder="Search Apps"
                      value={searchTerm}
                      onChange={this.handleChange}
                    />
                    <span className="input-group-label">
                      <Icon title="Search" name="search" size="1rem" />
                    </span>
                  </div>
                ) : null}
                {toggleDisplay === true ? (
                  <div className="flex flex-jc-sb flex-ai-c">
                    <div></div>
                    <Button
                      className="primary rounded mb-1"
                      onClick={this.closeToggle}
                    >
                      Back
                    </Button>
                  </div>
                ) : null}

                {toggleDisplay && currentKey ? (
                  this.renderComponent(currentKey)
                ) : (
                  <div>
                    {toggleDisplay === true ? (
                      <div></div>
                    ) : (
                      <div className="container-app-items">
                      {searchTerm === "" &&
                        this.props.profile && this.props.profile.profile.system_apps != null &&
                        this.props.profile.profile.system_apps.map((item) => {
                            return (
                              <div
                              className={`${
                                currentKey === item.appId ? "active" : ""
                              } ${this.isAllowedApp(item.id) == true ? "" : "app-disabled"}`}

                                onClick={() => this.switchComponent(item.appId)}
                              >
                                <CustomIcon2
                                  title={item.displayName}
                                  path={item.icon || aqiAirvedaIcon}
                                />
                                <h6>{item.displayName}</h6>
                              </div>
                            );
                          })}

                        


                        {searchTerm != "" &&
                          filteredList.map((item) => {
                            return (
                              <div
                              className={`${
                                currentKey === item.appId ? "active" : ""
                              } ${this.isAllowedApp(item.id) == true ? "" : "app-disabled"}`}

                                onClick={() => this.switchComponent(item.key)}
                              >
                                <CustomIcon2
                                  title={item.displayName}
                                  path={item.icon || aqiAirvedaIcon}
                                />
                                <h6>{item.displayName}</h6>
                              </div>
                            );
                          })}

                        {searchTerm === "" &&
                        this.props.profile && this.props.profile.profile.package.apps != null && this.props.profile.profile.package.apps
                          .filter((item) => item.published === true && item.set_visibility === 'specific')
                          .map((item) => {
                            return (
                              <div
                                className={currentKey === item.appId ? "active" : ""}
                                onClick={() => this.switchComponent(item.appId)}
                              >
                                <CustomIcon2
                                  title={item.displayName}
                                  path={item.icon || aqiAirvedaIcon }
                                />
                                <h6>{item.displayName}</h6>
                              </div>
                            );
                          })}

                        {searchTerm != "" &&
                          filteredFeaturesList
                          .filter((item) => item.published === true && item.set_visibility === 'specific')
                          .map((item) => {
                            return (
                              <div
                              className={
                                currentKey === item.appId ? "active" : ""
                              }
                              onClick={() => this.switchComponent(item.key)}
                            >
                              <CustomIcon2
                                title={item.displayName}
                                path={item.icon || aqiAirvedaIcon}
                                />
                              <h6>{item.displayName}</h6>
                            </div>
                            );
                          })}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </Box>
          )}
        </Box>
      </Page>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // state,
    profile: getProfile(state),
  };
};

export default connect(mapStateToProps, {
  fetchAssets,
  // toggleDeviceId,
  // updateDeviceGroup,
  // updateContentFeed,
  // fetchDeviceGroups,
  // confirmationRequest
})(AppPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/AppPage/index.js